import { loadableWithFallback } from '@vision/ui/utils';
import type { PieChart3Props } from './PieChart3';

export const PieChart3 = loadableWithFallback<PieChart3Props>(() => import('./PieChart3'));
